import { ThemeEvents } from '@theme/events';

class DroplandLotPotential extends HTMLElement {
  connectedCallback() {
    this.investment = Number(this.dataset.investment || 0) / 100;
    this.estimatedSale = Number(this.dataset.estimatedSale || 0) / 100;
    document.addEventListener(ThemeEvents.variantUpdate, this.onVariantUpdate);
    this.render();
  }

  disconnectedCallback() {
    document.removeEventListener(ThemeEvents.variantUpdate, this.onVariantUpdate);
  }

  onVariantUpdate = (event) => {
    const price = Number(event.detail?.resource?.price);
    if (Number.isFinite(price)) {
      this.investment = price / 100;
      this.render();
    }
  };

  format(value) {
    return new Intl.NumberFormat('es-MX', { style: 'currency', currency: this.dataset.currency || 'MXN', maximumFractionDigits: 0 }).format(value);
  }

  render() {
    const investment = this.querySelector('[data-lot-investment]');
    const sale = this.querySelector('[data-lot-sale]');
    const profit = this.querySelector('[data-lot-profit]');
    if (investment) investment.textContent = this.format(this.investment);
    if (this.estimatedSale > 0) {
      if (sale) sale.textContent = this.format(this.estimatedSale);
      if (profit) profit.textContent = `${this.estimatedSale - this.investment >= 0 ? '+' : ''}${this.format(this.estimatedSale - this.investment)}`;
    } else {
      if (sale) sale.textContent = 'Configura el valor estimado';
      if (profit) profit.textContent = '—';
    }
  }
}

if (!customElements.get('dropland-lot-potential')) {
  customElements.define('dropland-lot-potential', DroplandLotPotential);
}
